// src/redux/settingsPages/legalConsent/legalConsentSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchLegalConsent, updateLegalConsent } from './legalConsentActions';

const initialState = {
  consent: null,   // LegalConsentResponse: { terms_accept, privacy_accept, disclaimer_accept, *_version, *_accepted_at, updated_at }
  loading: false,
  error: null,
  updating: false,
  updateError: null,
};

const slice = createSlice({
  name: 'legalConsent',
  initialState,
  reducers: {
    clearLegalConsentError(state) {
      state.error = null;
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLegalConsent.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchLegalConsent.fulfilled, (s, a) => { s.loading = false; s.consent = a.payload; })
      .addCase(fetchLegalConsent.rejected, (s, a) => { s.loading = false; s.error = a.payload; })

      .addCase(updateLegalConsent.pending, (s) => { s.updating = true; s.updateError = null; })
      .addCase(updateLegalConsent.fulfilled, (s, a) => { s.updating = false; s.consent = a.payload; })
      .addCase(updateLegalConsent.rejected, (s, a) => { s.updating = false; s.updateError = a.payload; });
  },
});

export const { clearLegalConsentError } = slice.actions;
export default slice.reducer;
